/**
 * draft-body-style-from-viewer: 뷰어가 draft 본문 표시용 파싱에서 추출해 보고한 body 스타일
 * 골격(얕은 클론, 수백 바이트)의 host 측 보관소. draft 편집 열기(EmailForm initEditor)의
 * defaultStyle 시딩이 본문 전체 재파싱(2.7MB WebKit ~4s) 대신 이 골격을 파싱한다.
 *
 * stale 방어: 엔트리에 본문 길이(bodyLen)와 선두~body 열림 태그까지의 prefix 를 함께 보관하고,
 * 소비 시점의 실제 본문과 둘 다 일치할 때만 사용한다(불일치 → 기존 전체 파싱 폴백). draft 저장은
 * JMAP 특성상 새 email id 를 만들므로 id 충돌형 stale 은 구조적으로 드물다.
 *
 * 메모리: 엔트리당 수백 B~수 KB(골격+prefix). FIFO 상한으로 bound.
 */

export interface DraftBodyStyleEntry {
  skeletonHTML: string
  bodyLen: number
  bodyPrefix: string
}

const MAX_ENTRIES = 20

const cache = new Map<string, DraftBodyStyleEntry>()

export function setDraftBodyStyleSkeleton(emailId: string, entry: DraftBodyStyleEntry): void {
  if (emailId.length === 0 || entry.skeletonHTML.length === 0) return
  // 재보고 시 최신값으로 교체 + FIFO 순서 갱신.
  cache.delete(emailId)
  cache.set(emailId, entry)
  if (cache.size > MAX_ENTRIES) {
    const oldest = cache.keys().next().value
    if (oldest != null) cache.delete(oldest)
  }
}

/**
 * 골격 조회 + stale 검증. 현재 본문(bodyHTML)과 길이·prefix 가 모두 일치할 때만 골격을 반환하고,
 * 불일치(본문 변경)면 엔트리를 비우고 null — 호출부는 기존 전체 파싱으로 폴백한다.
 */
export function takeDraftBodyStyleSkeleton(emailId: string, bodyHTML: string): string | null {
  const entry = cache.get(emailId)
  if (entry == null) return null
  if (
    entry.bodyLen !== bodyHTML.length ||
    entry.bodyPrefix.length === 0 ||
    !bodyHTML.startsWith(entry.bodyPrefix)
  ) {
    cache.delete(emailId)
    return null
  }
  return entry.skeletonHTML
}

export function clearDraftBodyStyleSkeletons(): void {
  cache.clear()
}
